import { api } from '../../axios';

export const fetchSubscriptions = async (token: string) => {
  const response = await api.get('bx_block_subscriptions/subscriptions', {
    headers: { token: token }
  });

  return response.data;
};
